export const DATE_FORMATTER = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
export const NUMBER_FORMATTER = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });
export const INTEGER_FORMATTER = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

export const formatDateRange = (start: string, end: string) => {
	const startDate = new Date(start);
	const endDate = new Date(end);
	const sameYear = startDate.getFullYear() === endDate.getFullYear();
	const startLabel = DATE_FORMATTER.format(startDate);
	const endLabel = DATE_FORMATTER.format(endDate);
	return sameYear
		? `${startLabel} → ${endLabel} ${startDate.getFullYear()}`
		: `${startLabel} ${startDate.getFullYear()} → ${endLabel} ${endDate.getFullYear()}`;
};
